import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Box from 'ui-box';
import AntdAlertErrorBoundary from '../../components/common/AntdAlertErrorBoundary';
import MobileHeader from '../../components/mobile/Header';
import KnowledgeBankScreen from '../../pages/mobile/knowledge-bank/KnowledgeBankScreen';
import KnowledgeBankDetailScreen from '../../pages/mobile/knowledge-bank/KnowledgeBankDetailScreen';
import VideoHomeScreen from '../../pages/mobile/knowledge-bank/video/VideoHomeScreen';
import VideoDetailScreen from '../../pages/mobile/knowledge-bank/video/VideoDetailScreen';
import AudioHomeScreen from '../../pages/mobile/knowledge-bank/audio/AudioHomeScreen';
import AudioDetailScreen from '../../pages/mobile/knowledge-bank/audio/AudioDetailScreen';
import ReadHomeScreen from '../../pages/mobile/knowledge-bank/read/ReadHomeScreen';
import ReadDetailScreen from '../../pages/mobile/knowledge-bank/read/ReadDetailScreen';
import InfographicHomeScreen from '../../pages/mobile/knowledge-bank/infographic/InfographicHomeScreen';
import InfographicDetailScreen from '../../pages/mobile/knowledge-bank/infographic/InfographicDetailScreen';

function MobileKnowledgeBankLayout() {

  return (
    < >
      <Box position="relative" height="100%">
        <AntdAlertErrorBoundary>
          <MobileHeader />
        </AntdAlertErrorBoundary>
        <AntdAlertErrorBoundary>
          <Box paddingTop={30} paddingBottom={12} paddingX={20}>
            <Switch>
              <Route path="/knowledge-bank/detail/infographic/detail">
                <InfographicDetailScreen />
              </Route>
              <Route path="/knowledge-bank/detail/infographic">
                <InfographicHomeScreen />
              </Route>
              <Route path="/knowledge-bank/detail/read/detail">
                <ReadDetailScreen />
              </Route>
              <Route path="/knowledge-bank/detail/read">
                <ReadHomeScreen />
              </Route>
              <Route path="/knowledge-bank/detail/audio/detail">
                <AudioDetailScreen />
              </Route>
              <Route path="/knowledge-bank/detail/audio">
                <AudioHomeScreen />
              </Route>
              <Route path="/knowledge-bank/detail/video/detail">
                <VideoDetailScreen />
              </Route>
              <Route path="/knowledge-bank/detail/video">
                <VideoHomeScreen />
              </Route>
              <Route path="/knowledge-bank/detail">
                <KnowledgeBankDetailScreen />
              </Route>
              <Route path="/knowledge-bank">
                <KnowledgeBankScreen />
              </Route>
            </Switch>
          </Box>
        </AntdAlertErrorBoundary>
      </Box>
    </>
  );
}

export default MobileKnowledgeBankLayout;
